<template>
  <v-container grid-list-xl class="pa-0">
    <v-toolbar dense>
      <v-img class="ma-3" src="/img/logo.png" height="30px" width="40px"></v-img>
      <v-toolbar-title>
        BERKAS KITA
        (BERITA) - Seksi Infrastruktur Pertanahan
        Kantor Pertanahan Kota Malang
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon @click="toLogin">
        <v-icon>mdi-login</v-icon>
      </v-btn>
    </v-toolbar>
    <v-row wrap v-if="stat">
      <v-col cols="12" sm="6" md="4" lg="3" xl="3">
        <BlockCard
          title="Total Berkas"
          :value="stat.jumlah_berkas"
          icon="mdi-file"
          color="#FBC02D"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3" xl="3">
        <BlockCard
          title="Berkas Dalam Proses"
          :value="(stat.jumlah_berkas)-(stat.jumlah_selesai)"
          icon="mdi-file-clock"
          color="#4DB6AC"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3" xl="3">
        <BlockCard
          title="Berkas Selesai"
          :value="stat.jumlah_selesai"
          icon="mdi-file-check"
          color="#FFB74D"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3" xl="3">
        <BlockCard
          title="Presentase (%)"
          :value="stat.persen"
          icon="mdi-chart-areaspline"
          color="#F48C6C"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6" lg="6" xl="6">
        <span class="title white--text">Statistik Berkas Per Layanan</span>
        <MChartBar
          class="mt-5"
          title="Statistik Berkas Selesai Per Layanan"
          :op-series="berkas"
          :op-legend="false"
          :op-label="label"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="6" xl="6">
        <span class="title white--text">Performa Per Pegawai</span>
        <v-card class="mt-5" outlined tile>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th></th>
                  <th class="text-left">Nama</th>
                  <th class="text-left">Berkas Harus Dikerjakan</th>
                  <th class="text-left">Berkas Selesai Dikerjakan</th>
                  <th class="text-left">Pencapaian %</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="petugas in petugases" :key="petugas.id">
                  <td align="center">
                    <v-avatar :size="40" class="my-2" color="grey lighten-4">
                      <v-img
                        :src="petugas.foto?petugas.foto.url.thumbnail:'img/avatar-default.png'"
                        alt="avatar"
                      />
                    </v-avatar>
                  </td>
                  <td>{{ pVal(petugas, "name") }}</td>
                  <td>{{ pVal(petugas, "berkasdiserahkan_count") }}</td>
                  <td>{{ pVal(petugas, "berkasselesai_count") }}</td>
                  <td>{{ pVal(petugas, "persen") }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-col>
    </v-row>
    <v-footer height="90" app>
      <marquee-text :duration="50">
        <span v-for="item in marquee" :key="item.index" class="mx-5 headline">
          <v-icon large color="green">mdi-file</v-icon>Nomor :
          <b>{{pVal(item,'nomor')}} ({{item.nama}})</b>,
          Pemohon:
          <b>{{pVal(item,'nama_pemohon')}}</b>
          , Posisi Terakhir
          <v-chip
            label
            dark
            class="font-weight-medium red"
          >{{item.urutan_terakhir.urutan.keterangan}}</v-chip>&nbsp;oleh
          <b>{{item.urutan_terakhir.petugas.name}}</b>
          status
          <v-chip
            label
            dark
            :class="$berkas.statusColor(item.urutan_terakhir.status.id)"
          >{{item.urutan_terakhir.status.keterangan}}</v-chip>
        </span>
      </marquee-text>
    </v-footer>
  </v-container>
</template>

<script>
import BlockCard from "@/components/BlockCard";
import MChartLine from "@/components/MChartLine";
import MChartPie from "@/components/MChartPie";
import MChartBar from "@/components/MChartBar";
export default {
  components: {
    BlockCard,
    MChartLine,
    MChartPie,
    MChartBar
  },
  data() {
    return {
      stat: {},
      marquee: [],
      berkas: [],
      pekerjaan: [],
      labelpekerjaan: [],
      label: [],
      petugases: [{}],
      headers: [
        {
          text: "",
          align: "start",
          sortable: false,
          value: "foto"
        },
        { text: "Nama", value: "name" },
        { text: "Berkas Harus Dikerjakan", value: "berkasdiserahkan_count" },
        { text: "Berkas Selesai Dikerjakan", value: "berkasselesai_count" }
      ]
    };
  },
  mounted() {
    Promise.all([
      this.loadStatistik(),
      this.loadBeranda(),
      this.loadStatistikPetugas(),
      this.loadMarquee(),
      this.reloadAPI()
    ]);
  },
  activated() {
    // this.loadMarquee();
  },
  computed: {},
  methods: {
    toLogin() {
      this.$router.push({
        name: "login"
      });
    },
    loadBeranda() {
      this.$store.dispatch("laporan/statistik", 1).then(res => {
        this.stat = res;
      });
    },
    loadMarquee() {
      this.$store
        .dispatch("laporan/statistikTerakhir", 1)
        .then(res => {
          this.marquee = res;
        })
        .catch(e => e);
    },
    loadStatistik() {
      this.$store.dispatch("laporan/statistikLayanan", 1).then(res => {
        var seriesLabel = {
          normal: {
            show: true,
            textBorderColor: "#333",
            textBorderWidth: 2
          }
        };
        var berkasData = [
          {
            name: "Dalam Proses",
            type: "bar",
            label: seriesLabel,
            data: []
          },
          {
            name: "Selesai",
            type: "bar",
            label: seriesLabel,
            data: []
          }
        ];
        var label = [];

        res.forEach(function(item) {
          label.push(item.keterangan);
          berkasData[0].data.push(item.berkas_count);
          berkasData[1].data.push(item.berkasselesai_count);
        });
        this.berkas = berkasData;
        this.label = label;
      });
    },
    loadStatistikPetugas() {
      this.$store.dispatch("laporan/statistikPetugas", 1).then(res => {
        this.petugases = res;
        var berkasPekerjaanData = [
          {
            name: "Dalam Proses",
            type: "bar",
            label: "Dalam Proses",
            data: []
          },
          {
            name: "Selesai",
            type: "bar",
            label: "Selesai",
            data: []
          }
        ];
        var labelPekerjaan = [];

        res.forEach(function(item) {
          labelPekerjaan.push(item.name);
          berkasPekerjaanData[0].data.push(item.berkasdiserahkan_count);
          berkasPekerjaanData[1].data.push(item.berkasselesai_count);
        });
        this.pekerjaan = berkasPekerjaanData;
        this.labelpekerjaan = labelPekerjaan;
      });
    },

    reloadAPI() {
      var autoRefresh = setInterval(() => {
        if (this.$route.name == "dashboard") {
          this.loadBeranda();
          this.loadMarquee();
          this.loadStatistik();
          this.loadStatistikPetugas();
        } else {
          clearInterval(autoRefresh);
        }
      }, 300000);
    }
  }
};
</script>
